export default __webpack_public_path__ + "static/media/Line.4431afd5.webp";